export const TiktokSVG = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 13 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.375 0H9.1075C9.2335 0.625625 9.58 1.41487 10.1881 2.198C10.7831 2.96537 11.5724 3.5 12.625 3.5V5.25C11.0911 5.25 9.93875 4.53775 9.125 3.64962V9.625C9.125 10.4903 8.86841 11.3362 8.38768 12.0556C7.90695 12.7751 7.22367 13.3358 6.42424 13.667C5.62481 13.9981 4.74515 14.0847 3.89648 13.9159C3.04781 13.7471 2.26826 13.3304 1.65641 12.7186C1.04456 12.1067 0.627877 11.3272 0.459066 10.4785C0.290256 9.62985 0.376896 8.75019 0.708029 7.95076C1.03916 7.15133 1.59992 6.46805 2.31938 5.98732C3.03885 5.50659 3.88471 5.25 4.75 5.25V7C4.23083 7 3.72331 7.15395 3.29163 7.44239C2.85995 7.73083 2.5235 8.1408 2.32482 8.62045C2.12614 9.10011 2.07415 9.62791 2.17544 10.1371C2.27673 10.6463 2.52673 11.114 2.89385 11.4812C3.26096 11.8483 3.72869 12.0983 4.23789 12.1996C4.74709 12.3008 5.27489 12.2489 5.75455 12.0502C6.2342 11.8515 6.64417 11.515 6.93261 11.0834C7.22105 10.6517 7.375 10.1442 7.375 9.625V0Z"
      fill="var(--grey-95, #0C0D0D)"
    />
  </svg>
)